import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { ValuationResponse } from "../../../Controllers/Types/Project/DefaultService/ValuationResponce";
import { baseURL } from "../../ApiConstant";

export const valuationGetDataApi = async (seriviceId : number): Promise<ValuationResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/valuation/${seriviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
}

export const valuationCreateAPI = async (folder_id: number, valuation_no: number | null): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/valuation/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ folder_id, valuation_no}),

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const valuationUpdateAPI = async (valuationId: number, folder_id: number, valuation_no: number | null): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/valuation/update/${valuationId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: JSON.stringify({ folder_id, valuation_no}),

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const valuationDeleteAPI = async (valuationId: number): Promise<CommonApiResponse> => {
    try {        
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/valuation/delete/${valuationId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            }
        });
        
        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const valuationFeatureFileUploadAPI = async (valuationFeatureId: number, document_file: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        if (document_file) {
            formData.append('document_file', document_file);
        }

        const response = await fetch(`${baseURL}/api/valuation/file-upload/${valuationFeatureId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const valuationFeatureFileRemoveAPI = async (valuationFeatureId: number): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/valuation/file-delete/${valuationFeatureId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};